export default "__VITE_ASSET__DNIBR6Rp__"